<form [formGroup]="abschlussarbeitenForm" (ngSubmit)="submitArbeiten()">
  <label for="anzahl">Anzahl Abschlussarbeiten</label><br />
  <input type="number" name="anzahl" id="anzahl" formControlName="anzahl" />
  <button class="button" type="submit"><span>Speichern</span></button>
</form>
<p *ngIf="abschlussarbeitenSubmitted" style="color: green; font-weight: bold">
  Anzahl der Abschlussarbeiten aktualisiert
</p>
